import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'

import "../css/hugster-bootstrap.scss"
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import Main from '../vue/components/hugster/main.vue'

Vue.use(BootstrapVue)

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: h => h(Main)
  }).$mount()
  document.body.appendChild(app.$el)
})